import React, { useState } from 'react';
import { Eye, EyeOff, Mountain, Lock, Mail, Zap } from 'lucide-react';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin();
  };

  return (
    <div className="login-page">
      <div className="login-bg-pattern" />
      
      <div className="login-container">
        <div className="login-left">
          <div className="login-left-content">
            <Mountain size={48} strokeWidth={1.5} />
            <h2>GONTERO</h2>
            <p className="login-subtitle">Carrières & Matériaux</p>
            <div className="login-separator" />
            <p className="login-description">
              Accédez à votre espace client pour consulter vos documents, 
              suivre vos commandes et gérer vos paiements en toute simplicité.
            </p>
            <div className="login-features">
              <div className="login-feature">
                <div className="login-feature-dot" />
                <span>Factures & bons de livraison</span>
              </div>
              <div className="login-feature">
                <div className="login-feature-dot" />
                <span>Suivi de votre encours</span>
              </div>
              <div className="login-feature">
                <div className="login-feature-dot" />
                <span>Paiement en ligne sécurisé</span>
              </div>
            </div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-form-container">
            <div className="login-form-header">
              <h1>Connexion</h1>
              <p>Accédez à votre espace client</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="email">Adresse e-mail</label>
                <div className="input-wrapper">
                  <Mail size={18} className="input-icon" />
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@email.fr"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Mot de passe</label>
                <div className="input-wrapper">
                  <Lock size={18} className="input-icon" />
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
              </div>

              <div className="form-options">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span className="checkmark" />
                  Se souvenir de moi
                </label>
                <button type="button" className="link-button">Mot de passe oublié ?</button>
              </div>

              <button type="submit" className="login-submit">
                Se connecter
              </button>

              <div className="login-divider">
                <span>ou</span>
              </div>

              <button type="button" className="login-demo" onClick={onLogin}>
                <Zap size={18} />
                Accès direct démo
              </button>
            </form>

            <div className="login-footer">
              <p>Pas encore de compte ? Contactez votre commercial GONTERO</p>
              <p className="login-phone">04 42 XX XX XX</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
